import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const connectWise = defineConnector({
  identifier: "connectWise",
  name: "ConnectWise",
  tagLine: "IT management and automation platform",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ siteUrl }) =>
    `https://${siteUrl || "[^/]*"}/v4_6_release/apis/.*`,
  auth: (app) =>
    basicAuth({
      username: `${app.config.companyId}+${app.secret.publicKey}`,
      password: app.secret.privateKey,
    }),
  steps: [
    {
      title: "Create API keys",
      items: [
        {
          kind: "markdown",
          content:
            "In [ConnectWise](https://www.connectwise.com/) Manage, go to **System → Members → API Members** and create API keys. You’ll need your site URL, company ID, public key, and private key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Site URL",
          required: true,
          target: { kind: "configuration", field: "siteUrl" },
          helperText:
            "Your ConnectWise site URL (e.g., `na.myconnectwise.net`).",
        },
        {
          kind: "input",
          label: "Company ID",
          required: true,
          target: { kind: "configuration", field: "companyId" },
        },
        {
          kind: "input",
          label: "Public key",
          required: true,
          target: { kind: "secrets", field: "publicKey" },
        },
        {
          kind: "input",
          label: "Private key",
          required: true,
          target: { kind: "secrets", field: "privateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ siteUrl }) =>
      `https://${siteUrl}/v4_6_release/apis/3.0/system/info`,
  },
});
